
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetoalibaugbusonrent() {



    const cardData =
    {
        keyword: 'Pune to Alibaug Bus on Rent',
        heading: 'Amruta Travels: Pune to Alibaug Bus on Rent',
        headingDescription: 'Amruta Travels offers Pune to Alibaug Bus on Rent, providing a reliable and comfortable transportation solution for your coastal getaways. Whether you are planning a family vacation, corporate retreat, or group tour, our well-maintained buses ensure a smooth and enjoyable journey to Alibaug. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your travel to Alibaug simple and stress-free. Choose from our range of buses, including 14-seater, 17-seater, 20-seater, 25-seater, 32-seater, 35-seater, 40-seater, and 45-seater options, to suit your group size. Book your Pune to Alibaug Bus with Amruta Travels and embark on a journey of comfort and relaxation!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],
  "services": [
    {
      "name": "Pune to Alibaug Mini Bus On Rent",
      "description": "Travel comfortably from Pune to Alibaug with Amruta Travels' mini bus rental service. Our mini buses are ideal for small groups, providing air-conditioned comfort and ample space for a pleasant trip to Alibaug's beautiful beaches."
    },
    {
      "name": "Bus Rental Services in Pune",
      "description": "Amruta Travels offers reliable and affordable bus rental services in Pune for all your travel needs, including city tours, corporate events, school trips, and outstation journeys. Our fleet includes various bus sizes to accommodate your group comfortably."
    },
    {
      "name": "Pune to Alibaug Tempo Traveller on Rent",
      "description": "Book a Tempo Traveller for a comfortable ride from Pune to Alibaug. Our well-maintained vehicles offer air conditioning and ample space, ensuring a smooth and enjoyable journey for your group to the scenic coastal town of Alibaug."
    },
    {
      "name": "Pune to Alibaug Urbania on Rent",
      "description": "Travel in style with our Force Urbania luxury mini buses on rent for your trip from Pune to Alibaug. These vehicles offer premium seating, air conditioning, and smooth suspension, ensuring a luxurious and relaxing ride for your group."
    },
    {
      "name": "14, 17, 20, 25 Seater Bus Pune to Alibaug on Rent",
      "description": "Choose from a range of bus options including 14, 17, 20, and 25-seater buses for your group trip from Pune to Alibaug. These buses are spacious, comfortable, and come with air-conditioning, perfect for family outings or corporate picnics."
    },
    {
      "name": "Pune to Nagaon Beach Bus Hire",
      "description": "Enjoy a day trip to Nagaon Beach with Amruta Travels' bus rental service from Pune. Our comfortable, air-conditioned buses ensure a relaxing ride to the beach, ideal for family outings, group tours, or corporate trips."
    },
    {
      "name": "Pimpri Chinchwad to Alibag Bus on Rent",
      "description": "Residents of Pimpri Chinchwad can book a bus from Amruta Travels for a seamless journey to Alibaug. Whether it's a family vacation or a corporate retreat, our buses provide comfort, safety, and reliability for your trip."
    },
    {
      "name": "Pune Hadapsar to Pimpri Chinchwad Bus on Rent",
      "description": "Book a bus from Pune Hadapsar to Pimpri Chinchwad for various travel needs. Whether it's a corporate event, school trip, or family outing, our buses offer the ideal combination of comfort and convenience."
    },
    {
      "name": "32, 35, 40, 45 Seater Bus on Rent Pune to Alibaug",
      "description": "For larger groups, Amruta Travels offers 32, 35, 40, and 45-seater buses for hire from Pune to Alibaug. Our buses are air-conditioned, spacious, and perfect for groups planning a day trip or weekend getaway."
    },
    {
      "name": "Book Pune To Alibaug Tempo Traveller Hire On Rent",
      "description": "Easily book a Tempo Traveller from Pune to Alibaug with Amruta Travels. Our rental service provides comfortable and affordable travel options for groups of all sizes, ensuring a smooth and enjoyable journey to Alibaug."
    }
  ],
  "tableData": [
    ["Pune to Alibaug Mini Bus On Rent", "Bus Rental Services in Pune"],
    ["Pune to Alibaug Tempo Traveller on Rent", "Pune to Alibaug Urbania on Rent"],
    ["14, 17, 20, 25 Seater Bus Pune to Alibaug on Rent", "Pune to Nagaon Beach Bus Hire"],
    ["Pimpri Chinchwad to Alibag Bus on Rent", "Pune Hadapsar to Pimpri Chinchwad Bus on Rent"],
    ["32, 35, 40, 45 Seater Bus on Rent Pune to Alibaug", "Book Pune To Alibaug Tempo Traveller Hire On Rent"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Travel to Alibaug",
    "WhyChoosedescription": "Amruta Travels offers Pune to Alibaug Bus on Rent, providing a comfortable and scenic journey to the popular coastal town. Enjoy a smooth ride with spacious seating and air conditioning, ensuring a pleasant trip for your group."
  },
  {
    "WhyChooseheading": "Perfect for Group Outings and Family Trips",
    "WhyChoosedescription": "Our buses are ideal for family outings, school trips, corporate events, and group getaways to Alibaug. Travel together in comfort, convenience, and style while exploring this beautiful beach destination."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our professional drivers are well-acquainted with the Pune to Alibaug route and are committed to ensuring a safe and timely journey. Their expertise ensures you enjoy the trip with peace of mind."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive pricing for Pune to Alibaug Bus on Rent. We provide upfront, transparent pricing with no hidden charges, so you can easily plan your trip without any surprises."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are regularly cleaned and well-maintained to ensure a comfortable and hygienic travel experience. We prioritize your comfort and safety throughout the journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "We offer flexible pick-up and drop-off options from various locations in Pune. Whether you want to start from a specific hotel, office, or residential area, we can accommodate your preferences."
  },
  {
    "WhyChooseheading": "Customizable Travel Itinerary",
    "WhyChoosedescription": "We offer flexible routes and customizable itineraries for your trip to Alibaug. Whether you wish to visit specific beaches, temples, or other attractions, we can tailor your journey to meet your needs."
  },
  {
    "WhyChooseheading": "Easy Booking and Excellent Support",
    "WhyChoosedescription": "Booking a bus from Pune to Alibaug with Amruta Travels is simple and hassle-free. Our dedicated customer support team is here to assist you with all your travel arrangements and provide any help you need."
  }
]


































    }

const faqData = [
  {
    question: 'How can I rent a bus for a trip from Pune to Alibaug?',
    answer: 'Renting a bus for your trip from Pune to Alibaug with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll help you choose the right bus based on your group size and preferences.',
  },
  {
    question: 'What types of buses are available for the Pune to Alibaug trip?',
    answer: 'We offer various buses, including 32, 35, 45, and 50-seater options. Whether you need a standard or luxury bus, we have vehicles to fit your group and make your journey comfortable and memorable.',
  },
  {
    question: 'How long does it take to travel from Pune to Alibaug?',
    answer: 'The travel time from Pune to Alibaug is approximately 3 to 4 hours, depending on traffic and the chosen route. Our experienced drivers ensure a smooth and efficient journey.',
  },
  {
    question: 'Are the buses comfortable for the long journey to Alibaug?',
    answer: 'Yes, all our buses are well-maintained and come with comfortable seating, air conditioning, and ample space to ensure a comfortable and pleasant ride for all passengers during the journey.',
  },
  {
    question: 'Can I book a bus for a one-day trip to Alibaug?',
    answer: 'Yes, you can easily book a bus for a one-day trip to Alibaug. We’ll customize the itinerary according to your schedule to ensure you have a timely and enjoyable visit.',
  },
  {
    question: 'Do you offer both standard and luxury buses for the Pune to Alibaug trip?',
    answer: 'Yes, we provide both standard and luxury buses. Our luxury buses come with additional amenities such as premium seating, air conditioning, and more, ensuring a high-end travel experience.',
  },
  {
    question: 'How much does it cost to rent a bus for Pune to Alibaug?',
    answer: 'The cost depends on the bus size, trip duration, and any additional services you request. Please contact us for a customized quote based on your specific travel details.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. You can share your preferred locations, and we’ll plan the most convenient route to suit your needs.',
  },
  {
    question: 'Why choose Amruta Travels for a Pune to Alibaug bus rental?',
    answer: 'Amruta Travels offers reliable, comfortable, and timely bus services for your Pune to Alibaug trip. Our buses are well-maintained, our drivers are experienced, and we prioritize customer satisfaction to ensure a hassle-free journey.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Akash Thakur',
    role: 'Event Coordinator, Pune',
    text: 'We rented a 45-seater bus from Amruta Travels for a corporate outing to Alibaug. The service was excellent! The bus was clean, comfortable, and the driver was friendly and professional. Highly recommend for group trips!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Joshi',
    role: 'Traveler, Pune',
    text: 'Our family booked a 35-seater bus for a day trip to Alibaug, and it was a wonderful experience! The bus was spacious, air-conditioned, and had comfortable seating. The driver made the trip smooth and enjoyable. Great service!',
    rating: 5,
  },
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Alibaug Bus on Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-alibaug-bus-hire.jpg",
  "description": "Book a comfortable and affordable bus from Pune to Alibaug. Choose from Mini Buses, Tempo Travellers, and Urbania for a smooth journey to Alibaug, Nagaon Beach, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4532"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999", // Adjust the price accordingly
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-alibaug-bus-on-rent"
  }
};




    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Alibaug Bus on Rent | Affordable & Comfortable Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book your Pune to Alibaug bus with Amruta Travels. Choose from Mini Buses, Tempo Travellers, and Urbania buses for a smooth and enjoyable trip to Alibaug and nearby beaches." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoalibaugbusonrent;